import Base from '../base';
import ResizeObserver from 'resize-observer-polyfill';

const PAGE_WRAPPER_ID = '#js-page-wrapper';

class Flatex extends Base {
	constructor(el) {
		super(el);

		this.storedHeight = 0;

		window.addEventListener('load', () => this.onDocumentLoad());
	}

	onDocumentLoad() {
		const wrapper = document.body.querySelector(PAGE_WRAPPER_ID);

		// Event listeners
		const observer = new ResizeObserver((entries) => {
			Array.from(entries).forEach((entry) => {
				this.onResize(entry);
			});
		});

		observer.observe(wrapper);
	}

	onResize(entry) {
		const { target } = entry;

		if (target.clientHeight === this.storedHeight) {
			return;
		}

		this.storedHeight = target.clientHeight;
		this.updateIframeUrl(target.clientHeight);
	}

	updateIframeUrl(height) {
		this.el.src = `${this.options.baseUrl}?height=${height}`;
	}
}

export default Flatex;
